import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { myMenuSurveyRequest } from "../../services/myMenuSurveyService";
import { getToken } from "../../utils/utility";
import { notification } from "antd";

export function* getMyMenuSurvey({ startDate, endDate, selectedRestaurant }) {
  try {
    const token = getToken().get("idToken");
    if (selectedRestaurant.length <= 0) return;
    if (selectedRestaurant[0] === null) return;
    if (selectedRestaurant[0] === undefined) return;
    const response = yield call(
      myMenuSurveyRequest,
      token,
      startDate,
      endDate,
      selectedRestaurant
    );

    if (response[0] === 200) {
      yield put({
        type: actions.MY_MENU_SURVEY_SUCCESS,
        surveyReport: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export default function* rootSaga() {
  yield all([yield takeEvery(actions.MY_MENU_SURVEY_REQUEST, getMyMenuSurvey)]);
}
